import { ICellRendererParams } from '@ag-grid-community/core'
import { AxiosError } from 'axios'
import { Button } from 'components/common'
import Modal from 'components/modal'
import toast from 'react-hot-toast'
import { deleteAggregator } from 'utils/api/aggregatorApi'

type Props = {
  isOpen: boolean
  closeModal: () => void
  params?: ICellRendererParams
}

const ConfirmDeleteAggregatorModal = ({
  params,
  closeModal,
  isOpen,
}: Props) => {
  // close the modal and untick the delete aggregator checkbox
  const cancelDeleteStore = () => {
    if (params?.data?._id) {
      const rowNode = params.api.getRowNode(params.data._id)
      rowNode?.setSelected(false)
    }
    closeModal()
  }

  // delete the aggregator and remove from table
  const deleteStore = async () => {
    if (params?.data?._id) {
      const deleteToast = toast.loading('Deleting Aggregator...', {
        duration: Infinity,
      })
      try {
        // deleting aggregator
        await deleteAggregator(params.data._id)

        // remove row from table
        const rowNode = params.api.getRowNode(params.data._id)
        params.api.applyTransaction({ remove: [rowNode?.data] })

        toast.success(`Data Deletion for ${params?.data?._id} Initiated!`, {
          duration: 3000,
          id: deleteToast,
        })

        // closing modal
        closeModal()
      } catch (error) {
        if (error instanceof AxiosError) {
          if (error?.response?.data?.errors?.msg?.runningService) {
            return toast.error(error.response.data.errors.msg.runningService, {
              id: deleteToast,
              duration: 3000,
            })
          }
        }
        toast.error('Failed to delete aggregator.', {
          duration: 3000,
          id: deleteToast,
        })
      }
    }
  }

  return (
    <Modal
      width={550}
      title={`Confirm delete "${params?.data?.aggregatorName}" ?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={cancelDeleteStore}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <div>
          Deleting <strong>{params?.data?.aggregatorName}</strong> aggregator
          will remove all associated data from{' '}
          <strong className="text-error">Pricing</strong>,{' '}
          <strong className="text-error">Magento API</strong>,{' '}
          <strong className="text-error">FTP Configurations</strong>, and{' '}
          <strong className="text-error">Master Data</strong>. Are you sure you
          want to proceed with the deletion?
        </div>

        {/* Actions */}
        <div className="mt-6 flex w-full items-center gap-5">
          <Button
            onClick={deleteStore}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelDeleteStore}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmDeleteAggregatorModal
